import React from "react";

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 py-16 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-xl text-center">
        <h1 className="text-4xl font-bold mb-2 text-gradient bg-gradient-to-r from-indigo-500 via-pink-500 to-purple-500 bg-clip-text text-transparent">Contact Us</h1>
        <p className="text-lg text-gray-700 mb-6">For any questions, support, or partnership opportunities, please email us at</p>
        <a href="mailto:inflatein@gmail.com" className="text-xl font-semibold text-indigo-600 underline mb-8 inline-block">inflatein@gmail.com</a>
        <div className="mt-8 border-t pt-6 text-gray-600 text-sm">
          <div className="mb-2">
            <span className="font-semibold">Address:</span> Bengaluru, India
          </div>
          <div>
            <span className="font-semibold">Support Hours:</span> Mon-Fri, 9am – 6pm IST
          </div>
        </div>
      </div>
    </div>
  );
}
